export default __webpack_public_path__ + "static/media/raccoon_4.a2f5dea3.png";